import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const NotFound = () => {
  return (
    <div
      data-testid="not-found-page"
      className="flex min-h-screen flex-col items-center justify-center bg-white px-4 text-center font-body"
    >
      <img src="/assets/logo-tryvitta.jpeg" alt="TryVitta Fitness" className="h-14 w-auto rounded-xl" />
      <h1 className="mt-8 font-display text-6xl font-black tracking-tighter text-brand">404</h1>
      <p className="mt-3 max-w-sm text-sm font-semibold leading-relaxed text-slate-500">
        Esta página não existe. Mas sua jornada pode começar agora.
      </p>
      <Link
        data-testid="not-found-home-link"
        to="/"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand px-7 py-3.5 font-display text-sm font-bold text-white shadow-glow transition-all duration-300 hover:scale-[1.03] hover:bg-brand-dark"
      >
        <ArrowLeft className="h-4 w-4" /> Voltar para o início
      </Link>
    </div>
  );
};
